import { Col } from "react-bootstrap";
import { MapPin, Users, Phone } from "lucide-react";

const CompanyLocationCol = (props) => {
    const loc = props;
    return (
        <Col key={loc.location.location_city} xs="6" md="4" lg="3" className="py-3 mb-3 mb-lg-0">
            <div className="label-heading">
                {loc.location.location_country?.label}
            </div>
            <p className="text-sm fw-bold">
                {loc.location.location_city}
            </p>
            <div className="d-flex text-sm text-muted mb-3">
                <MapPin className="me-2 d-inline-block align-middle" size={16} />
                <div className="mt-n1">
                    {loc.location?.location_zip.length > 1 ? (
                        `${loc.location.location_street}, ${loc.location.location_zip}`
                    )
                        : (`${loc.location.location_street}`)
                    }
                </div>
            </div>
            <p className="text-sm text-muted">
                <Users
                    className="me-2 d-inline-block align-middle"
                    size={16}
                />
                {loc.location.location_size?.label}
            </p>
            {(loc.location.location_phone.length > 5) && (
                <p className="text-sm text-muted">
                    <Phone
                        className="me-2 d-inline-block align-middle"
                        size={16}
                    />
                    <a href={`tel:${loc.location.location_phone}`} className="text-muted">{loc.location.location_phone}</a>
                </p>
            )
            }
        </Col>
    )
}

export default CompanyLocationCol;